import { createApp } from "vue"

import { setupI18n } from "@/locales"
import router from "@/plugins/router"
import store from "@/plugins/store"
import { reportSentry } from "@/utils/sentry"
import { useSentry } from "@/utils/sentry"

import App from "./App.vue"
import "./assets/main.css"

async function main() {
  const i18n = setupI18n() // uses saved preference or browser language

  const token = localStorage.getItem("swatchon-partner-token")
  if (token && token.trim()) {
    store.commit("saveToken", token.trim())
    try {
      await store.dispatch("loadPartner", { force: true })
    } catch (error) {
      console.warn("Failed to load partner data")
      reportSentry(error)
    }
  }

  // initialize data
  await store.dispatch("loadCountries")
  await store.dispatch("loadProperties")

  const app = createApp(App)

  useSentry(app)

  app.use(store)
  app.use(router)
  app.use(i18n)
  app.mount("#app")
}

main()
